import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { RenderFormComponent } from './render-form.component';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { DragDropModule  } from '@angular/cdk/drag-drop';
import { ConfigService } from './services/config.service';

@NgModule({
  declarations: [
    AppComponent,
    RenderFormComponent
  ],
  imports: [
    BrowserModule,
    DynamicFormModule,
    DragDropModule,
    NgbModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [ConfigService],
  // bootstrap: [AppComponent],
  entryComponents: [
    AppComponent,
    RenderFormComponent
  ]
})
export class AppModule {
  constructor(injector: Injector) {
    // Using Angular elements - to create a custom element 'build-form' in the DOM
    const el = createCustomElement(AppComponent, { injector });
    customElements.define('build-form', el);

    // Using Angular elements - to create a custom element 'render-form' in the DOM
    const e2 = createCustomElement(RenderFormComponent, { injector });
    customElements.define('render-form', e2);
  }

  ngDoBootstrap() {
  }
}
